/* businesses */
export const GET_COURSE_KNOWLEDGES = "GET_COURSE_KNOWLEDGES"
export const GET_COURSE_KNOWLEDGES_SUCCESS = "GET_COURSE_KNOWLEDGES_SUCCESS"
export const GET_COURSE_KNOWLEDGES_ERROR = "API_ERROR"
